import React from 'react'

const RU = (props) => {
    return (
        <svg {...props} width={props.width ? props.width : '24'} height={props.height ? props.height : '24'}
             xmlns="http://www.w3.org/2000/svg" id="flag-icons-us" viewBox="0 0 640 480">
            <path fill="#fff" d="M0 0h640v160H0z"/>
            <path fill="#0039a6" d="M0 160h640v160H0z"/>
            <path fill="#d52b1e" d="M0 320h640v160H0z"/>
        </svg>
    )
}

export default RU;


// WEBPACK FOOTER //
// ./src/assets/flags/RU.jsx